import { Box, IconButton, styled } from '@mui/material';

export const StyledTurnaroundZoneBox = styled(Box)`
    background-color: white;
    color: black;
    border-radius: 5px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &.cancelled {
        background-color: #f26322;
    }

    &.alert {
        outline: 2px solid ${({ theme }) => theme.palette.error.main};
    }
`;
export const StyledColorBox = styled(Box)<{ terminalcolor: string }>`
    width: 6px;
    height: 12px;
    background-color: ${({ terminalcolor }) => (terminalcolor ? terminalcolor : '')};
    border-radius: 5px;
`;
export const StyledIndicatorsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const StyledIconButton = styled(IconButton)`
  background-color: #0096FF;
  height: 25px;
  width: 25px;
  border-radius: 5px;

  &:hover {
    background-color: #0096FF
  }

,
`;
export const StyledTurnaroundFlightNumberBox = styled(Box)`
    font-weight: 500;
    font-size: 11px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;
